export const SCORE_TYPE = {
  CREDIT_RISK: 'CREDIT_RISK',
  PERFORMANCE: 'PERFORMANCE',
}

export const PERFORMANCE_SCORE_COLOR = [
  '#EB6671',
  '#FFDE86',
  '#C3D785',
  '#87D4A4',
]

export const TRENDING = {
  NOT_AVAILABLE: 'NotAvailable',
  FIRST_SCORE: 'FirstScore',
  INCREASE: 'Increase',
  DECREASE: 'Decrease',
  SIDEWAY: 'Sideway',
}
